import _kebabCase from 'lodash/kebabCase';
import { Google } from '../analytics/index.js';

/**
 * @summary Sends Google events for home services cta link
 * @data co_txt_url
 * @events event1
 */
export async function homeServicesCTAClick(_ref, option) {
  let {
    data = {}
  } = _ref;
  Google.sendClickEvent({
    eventElement: 'search-car',
    eventAction: 'search',
    eventResult: `text-link::${data.destinationPage}::${_kebabCase(data.co_txt_url)}`
  }, option);
  return {};
}

/**
 * @summary Sends Google events for home services video status
 * @data videoNum
 * @events event1, event 32
 */
export async function homeServicesMediaEvent(_ref2, option) {
  let {
    data = {},
    event
  } = _ref2;
  let eventType; // for GA (note: we are not firing the 'pause' event for GA)
  switch (event.eventLabel) {
    case 'pause':
      break;
    case 'complete':
      eventType = 'complete';
      break;
    default:
      eventType = 'start';
  }
  if (eventType) {
    Google.sendClickEvent({
      eventElement: 'video',
      eventAction: 'view',
      eventResult: `${data.originPage}::video-${data.videoNum}::${eventType}`
    }, option);
  }
  return {};
}
export default {
  homeServicesCTAClick,
  homeServicesMediaEvent
};